import { Injectable } from '@angular/core';
import { Observable  } from "rxjs/Observable";
import { Subscriber } from "rxjs/Subscriber";

@Injectable()
export class ThemeService {
    currentTheme = process.env.config.theme;
    stylesheetTheme: string = 'absav2';

    constructor() {
        if (document.getElementById('theme')) {
            let stylesheet = document.getElementById('theme') as HTMLLinkElement;
            let stylesheetArray = stylesheet.href.split('/');
            let stylesheetTheme = stylesheetArray[stylesheetArray.length-1];
            this.stylesheetTheme = stylesheetTheme.substring(0, stylesheetTheme.lastIndexOf('.'))
        }
    }

    /**
     * Solution for configurable themes 
     */
    changeThemeTo(theme: string): Observable<string> {        
        return Observable.create((sub: Subscriber<string>) => {                        
            if (this.stylesheetTheme.substring(0, this.stylesheetTheme.indexOf('.')) != theme.toLowerCase())  {
                var sheet = document.getElementById('theme') as HTMLLinkElement;
                var href = sheet.href;
                /* replacing only .css portion */
                sheet.setAttribute('href', href.replace(this.stylesheetTheme+'.css', theme+'.css'));
                
                var favicon = document.getElementById('favicon') as HTMLLinkElement;
                var favicon_href = favicon.href;
                /* replacing only .ico portion */
                favicon.setAttribute('href', favicon_href.replace(this.stylesheetTheme+'.ico', theme+'.ico'));
                this.currentTheme = theme.toLowerCase();
                this.stylesheetTheme = theme.toLowerCase();
            }

            // publish current theme even if not changed
            // this is to ensure the theme file and redux theme value are in sync during initialization
            sub.next(theme.toLowerCase());

            sub.complete();
        });
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/services/theme.service.ts